import { useEffect, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../auth";
import { cmsHost } from "../lib/languages";

export function AuthCallbackPage() {
  const { completeAppleRedirect, isAdmin, sessionToken } = useAuth();
  const [params] = useSearchParams();
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const host = cmsHost();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const fromQuery = params.get("id_token");
      const fromHash = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("id_token");
      const identityToken = fromQuery || fromHash;
      if (!identityToken) {
        setError("No Apple identity token in the callback URL.");
        return;
      }
      try {
        await completeAppleRedirect(identityToken);
        if (!cancelled) setDone(true);
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : "Sign-in failed.");
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [completeAppleRedirect, params]);

  if (done || (sessionToken && isAdmin)) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="login-wrap">
      <div className="panel login-card stack">
        <div className="login-hero">
          <div className="logo" aria-hidden="true">
            G
          </div>
          <h1>{error ? "Sign-in incomplete" : "Completing sign-in"}</h1>
          <p>{host}</p>
        </div>
        {error ? (
          <div className="error-banner" role="alert">
            {error}
          </div>
        ) : (
          <p className="login-body">Verifying your Apple identity token…</p>
        )}
      </div>
    </div>
  );
}
